export default "__VITE_ASSET__GvMREKWw__"